<template>
    <div>
        <q-modal class="modal-detail" v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
            <div>
                <v-header
                    v-if="$q.screen.gt.sm"
                    :title="$route.name === 'sales-expert.orders.in-lending' || $route.name === 'lending-point.orders.in-lending'
                    ? $T('how has the loan ended?')
                    : ($T('order') + ' ' + (form.id || '') + ' - ' + (form['order_status.description'] ? form['order_status.description'] : ''))"
                >
                    <template slot="right">
                        <v-button flat rounded dense color="primary"
                                icon="fa icon-close"
                                :disable="form.busy"
                                @click="close"></v-button>
                    </template>
                </v-header>
                <v-header class="header-modal-mobile" v-else>
                    <template slot="right">
                        <v-button flat rounded dense color="primary"
                                icon="fa icon-close"
                                :disable="form.busy"
                                @click="close"></v-button>
                    </template>
                </v-header>
                <card width="100%" v-if="mockData" :class="isMobile ? 'card-mobile' : ''">
                    <div>
                        <q-collapsible
                            :label="$T('loan details') + ' ' + lendingKit || item['lending_kit.codentify']"
                            collapse-icon="fa icon-chevron-down"
                            id="collapsible-order-detail"
                            v-model="isCollapsibleOpen"
                        >
                            <div v-if="isMobile" class="column bg-hard-white items-center">
                                <div class="row justify-between items-center default-height border-title width-row q-px-md">
                                    <span class="font-label text-weight-bold text-right col-4">{{ $T('start date') }}</span>
                                    <span class="font-mobile-collapse col-7">{{ item.start_lending_at }}</span>
                                </div>
                                <div v-for="(item,index) in dataDetailModal" :key="index" :ref="`${index}`" class="row justify-between items-center default-height border-content width-row q-px-md">
                                    <span class="font-label text-right col-4">{{ item.column }}</span>
                                    <span class="font-mobile-collapse col-7">{{ item.data }}</span>
                                </div>
                            </div>
                            <div v-else>
                                <TableDetail v-if="mockData" :data="dataItem" :columns="orderDetailColumns"/>
                            </div>
                        </q-collapsible>
                        <div v-if="$q.screen.lt.md">
                            <v-radio-buttons v-if="actions.length >= 1"
                                id="radio-modal-table"
                                path="action"
                                v-model="action"
                                :label="$T('select loan completion mode')"
                                :options="actions"
                                :form="form"
                                @input="makeActionDataAdjustments"
                                class="col-9">
                            </v-radio-buttons>
                            <template v-if="action == 1 || action === 5">
                                    <div class="column items-start q-pl-lg q-pt-md" style="align-items:center;">
                                        <p class="text-primary" style="font-size:16px!important;cursor:default!important;">¿Cuál es el motivo del consumidor para no comprar IQOS? </p>
                                        <div class="select-modal-table row justify-between items-center q-ml-lg" @click="openList">
                                            <span>{{ !reasonChoosed ? $T('select a reason') : mockData.noSoldReasons.find(item => item.value === reasonChoosed).label}}</span>
                                            <q-icon v-if="showIconDropdown" :class="showList ? 'rotate' : 'not-rotate'" name="fa icon-chevron-down"></q-icon>
                                            <img v-if="showOkImg" src="./../../img/ok-form.svg" width="24px" height="24px" />
                                        </div>
                                        <div v-show="showList" class="content-list-modal-table">
                                            <q-scroll-area class="select-reason" style="height:160px;">
                                                <q-list path="no_sold_reason_id" class="list-select" no-border>
                                                    <q-item v-for="item in mockData.noSoldReasons" :key="item.value">
                                                        <q-item-main :label="item.label" @click.native="saveReason(item)" />
                                                    </q-item>
                                                </q-list>
                                            </q-scroll-area>
                                        </div>
                                    </div>
                            </template>
                            <div class="row justify-center q-py-xl">
                                <v-button v-if="(orderStatuses['PENDING_PICKUP'] === form['order_status.description'] &&
                                            'Courier' === user.role.name) ||
                                            ([1, 2, 3, 4].includes(action) &&
                                            orderStatuses['IN_LENDING'] === form['order_status.description'] &&
                                            ('Lending Point' === user.role.name ||  'Sales Expert' === user.role.name || 'MUPI' === user.role.name ||
                                            user.role.name === 'Call Center' ||  'Remote Coach' === user.role.name))"
                                        rounded
                                        :label="$T('save')"
                                        color="primary"
                                        :id="reasonChoosed === null && (action == 1 || action === 5) ? 'btn-disable' : ''"
                                        class="no-shadow capitalize btn-modal-table"
                                        @click="moveTo('completed', stockActions.find(a => a.value == stockAction).stockStatus)"
                                        :loading="form.busy"
                                        :disable="form.busy">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>
                            </div>
                        </div>
                    </div>
                    <div v-if="$route.name === 'sales-expert.orders.in-lending' || $route.name === 'lending-point.orders.in-lending' || $route.name === 'sales-expert.orders' || $route.name === 'lending-point.orders'">
                        <form v-if="mockData && user && $q.screen.gt.sm"
                            class="row gutter-xs"
                            @keydown="form.onKeydown($event)">

                            <v-radio-buttons v-if="actions.length >= 1"
                                            id="radio-modal-table"
                                            path="action"
                                            v-model="action"
                                            :label="$T('select loan completion mode')"
                                            :options="actions"
                                            :form="form"
                                            @input="makeActionDataAdjustments"
                                            class="col-9">
                            </v-radio-buttons>

                            <template v-if="action == 1 || action === 5">

                                <div>
                                    <div class="column items-start q-pl-lg q-pt-md position-inside">
                                        <p class="text-primary" style="font-size:16px!important;cursor:default!important;">¿Cuál es el motivo del consumidor para no comprar IQOS? </p>
                                        <div class="select-modal-table row justify-between items-center q-ml-lg" @click="openList">
                                            <span>{{ !reasonChoosed ? $T('select a reason') : mockData.noSoldReasons.find(item => item.value === reasonChoosed).label}}</span>
                                            <q-icon v-if="showIconDropdown" :class="showList ? 'rotate' : 'not-rotate'" name="fa icon-chevron-down"></q-icon>
                                            <img v-if="showOkImg" src="./../../img/ok-form.svg" width="24px" height="24px" />
                                        </div>
                                        <div v-show="showList" class="content-list-modal-table">
                                            <q-scroll-area class="select-reason" style="height:160px;">
                                                <q-list path="no_sold_reason_id" class="list-select" no-border>
                                                    <q-item v-for="item in mockData.noSoldReasons" :key="item.value">
                                                        <q-item-main :label="item.label" @click.native="saveReason(item)" />
                                                    </q-item>
                                                </q-list>
                                            </q-scroll-area>
                                        </div>
                                    </div>
                                </div>

                            </template>

                            <!-- Submit Button -->
                            <div class="col-12 row justify-center q-mt-md group">

                                <!-- Call Center - Move from Reserved or In Transit to Cancelled -->
                                <v-button v-if="[orderStatuses['RESERVED'], orderStatuses['IN_TRANSIT']].includes(form['order_status.description']) &&
                                            user.role.name === 'Call Center'"
                                        outline
                                        :label="$T('cancel order')"
                                        icon="cancel"
                                        color="negative"
                                        :loading="form.busy"
                                        :disable="form.busy"
                                        class="no-shadow uppercase q-btn-iqos">
                                    <q-popover>
                                        <div class="group text-center">
                                            <p><strong>{{ $T('are you sure?') }}</strong></p>
                                            <v-button class="no-shadow capitalize" color="negative" no-caps
                                                    @click="moveTo('cancelled')" v-close-overlay>
                                                {{ $t('yes') }}
                                            </v-button>
                                            <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                                                {{ $t('no') }}
                                            </v-button>
                                        </div>
                                    </q-popover>
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>

                                <!-- Call Center - Request Pickup -->
                                <v-button v-if="[5, 6].includes(action) &&
                                            'Call Center' === user.role.name"
                                        outline
                                        :label="$T('request pickup')"
                                        icon="save"
                                        color="highlight"
                                        class="no-shadow uppercase q-btn-iqos"
                                        :loading="form.busy"
                                        :disable="form.busy"
                                        @click="moveTo('pending-pick-up')">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>

                                <!-- Courier - Move from Reserved to In Transit -->
                                <v-button v-if="orderStatuses['RESERVED'] === form['order_status.description'] &&
                                            'Courier' === user.role.name"
                                        outline
                                        :label="$T('move to in transit')"
                                        icon="save"
                                        color="highlight"
                                        class="no-shadow uppercase q-btn-iqos"
                                        :loading="form.busy"
                                        :disable="form.busy"
                                        @click="moveTo('in-transit')">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>

                                <!-- Courier - Move from In Transit to In Lending -->
                                <!-- Lending Point - Move from Reserved to In Lending -->
                                <v-button v-if="(orderStatuses['IN_TRANSIT'] === form['order_status.description'] &&
                                            'Courier' === user.role.name) ||
                                            (orderStatuses['RESERVED'] === form['order_status.description'] &&
                                            ('Lending Point' === user.role.name ||  'Sales Expert' === user.role.name || 'MUPI' === user.role.name ||
                                            'Call Center' === user.role.name || 'Remote Coach' === user.role.name ))"
                                        outline
                                        :label="$T('delivered order - move to in lending')"
                                        icon="save"
                                        color="highlight"
                                        class="no-shadow uppercase q-btn-iqos"
                                        :loading="form.busy"
                                        :disable="form.busy"
                                        @click="moveTo('in-lending')">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>
                                <!-- Lending Point - Move from PENDING to In Lending -->
                                <v-button
                                    v-if="orderStatuses['PENDING'] === form['order_status.description'] && ('Lending Point' === user.role.name || 'Sales Expert' === user.role.name || 'MUPI' === user.role.name || 'Remote Coach' === user.role.name)"
                                    outline
                                    :label="$T('move to in lending')"
                                    icon="save"
                                    color="highlight"
                                    class="no-shadow uppercase q-btn-iqos"
                                    :loading="form.busy"
                                    :disable="!(form.terms_and_conditions) || form.busy"
                                    @click="moveTo('in-lending', 'in-lending')">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>

                                <!-- Courier - Move from Pending Pickup to Completed -->
                                <!-- Lending Point - Move from In Lending to Completed -->
                                <!-- Kit Returned - Move from Not Returned to Completed -->
                                <v-button v-if="(orderStatuses['NOT_RETURNED'] === form['order_status.description']) && ([20].includes(action)) ||
                                (orderStatuses['PENDING_PICKUP'] === form['order_status.description'] &&
                                            'Courier' === user.role.name) ||
                                            ([1, 2, 3, 4].includes(action) &&
                                            (orderStatuses['IN_LENDING'] === form['order_status.description'] || orderStatuses['IN_LENDING_DELAYED'] === form['order_status.description'])  &&
                                            ('Lending Point' === user.role.name ||  'Sales Expert' === user.role.name ||
                                            'MUPI' === user.role.name || user.role.name === 'Call Center' ||  'Remote Coach' === user.role.name))"
                                        rounded
                                        :label="$T('save')"
                                        :id="reasonChoosed === null && (action == 1 || action === 5) ? 'btn-disable' : ''"
                                        color="primary"
                                        class="no-shadow capitalize btn-modal-table"
                                        @click="moveTo('completed', stockActions.find(a => a.value == stockAction).stockStatus)"
                                        :loading="form.busy"
                                        :disable="form.busy">
                                    <template slot="loading">
                                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                        {{ $T('saving...') | capitalize }}
                                    </template>
                                </v-button>
                            </div>

                </form>
                    </div>
            </card>
            </div>
        </q-modal>
        <q-modal v-model="modalEndDate" no-backdrop-dismiss no-esc-dismiss>
            <div>
                <card width="100%">

                    <form class="row gutter-xs"
                          @keydown="form.onKeydown($event)">

                        <v-datetime path="end_lending_at"
                                    v-model="form.end_lending_at"
                                    :label="$t('lending end date')"
                                    format-data="YYYY-MM-DD"
                                    format="DD-MM-YYYY"
                                    :form="form"
                                    :disable="orderStatuses['IN_LENDING'] !== form['order_status.description']"
                                    class="col-12">
                        </v-datetime>

                        <!-- Submit Button -->
                        <div class="col-12 row justify-center q-mt-md group">

                            <!-- Save changes -->
                            <v-button outline
                                      :label="$T('cancel')"
                                      icon="close"
                                      color="danger"
                                      class="no-shadow uppercase q-btn-iqos"
                                      @click.prevent="cancelEndDate">
                            </v-button>

                            <!-- Save changes -->
                            <v-button v-if="orderStatuses['IN_LENDING'] === form['order_status.description']"
                                      outline
                                      :label="$T('save')"
                                      icon="save"
                                      color="info"
                                      :loading="form.busy"
                                      :disable="form.busy"
                                      class="no-shadow uppercase q-btn-iqos"
                                      @click.prevent="save">
                                <template slot="loading">
                                    <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                    {{ $T('saving...') | capitalize }}
                                </template>
                            </v-button>
                        </div>
                    </form>
                </card>
            </div>

            <terms-and-conditions v-if="termsAndConditions" :form="form" :mock-data="mockData"
                                @close-terms-and-conditions="termsAndConditions = false"
                                @accept-terms-and-conditions="acceptTermsAndConditions">
            </terms-and-conditions>
        </q-modal>
        <q-dialog
            v-model="dialog"
            prevent-close
            @ok="onOk"
            @cancel="onCancel"
        >
            <span class="text-weight-bold" slot="title">
                    <div class="row justify-end">
                        <q-icon name="fa icon-close cursor-pointer" @click.native="closeDialog"/>
                    </div>
                    <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                        {{ $T("do you want to register another device to the consumer to continue with your loan?") }}
                        <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                    </div>
            </span>

            <template slot="buttons" slot-scope="props">
                <div :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'" class="items-center">
                    <q-btn class="no-shadow new-btn" :class="isMobile ? 'q-mb-md full-width' : 'col-4'" no-caps outline rounded color="primary" :label="$T('no')" @click.native="props.cancel" />
                    <q-btn class="no-shadow new-btn" :class="isMobile ? 'q-mb-md full-width' : 'col-4'" no-caps color="highlight" text-color="primary" rounded :label="$T('yes')" @click.native="props.ok" />
                </div>
            </template>
        </q-dialog>
        <q-dialog
            v-model="lastDialog"
            prevent-close
            @ok="onLastOk"
        >
            <span class="text-weight-bold" slot="title">
                    <div class="row justify-end">
                        <q-icon name="fa icon-close cursor-pointer" @click.native="closeLastDialog"/>
                    </div>
                    <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                        {{ messageModal }}
                        <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                    </div>
            </span>

            <template slot="buttons" slot-scope="props">
                <div :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'" class="items-center">
                    <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="no-shadow new-btn" no-caps rounded color="primary" :label="$T('close')" @click="props.ok"/>
                </div>
            </template>
        </q-dialog>
    </div>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import orderModel from './orderModel'
import consumerModel from './consumerModel'
import {
    QSpinnerPuff,
    QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import VDatetime from '../components/form/VDatetime'
import VDisplay from '../components/form/VDisplay'
import TermsAndConditions from "./termsAndConditions"
import TableDetail from '../components/TableDetail.vue'
// import { Platform } from 'quasar'

export default {
    mixins: [orderModel, consumerModel],

    components: {
        VDisplay,
        VDatetime,
        QSpinnerPuff,
        QModal,
        TermsAndConditions,
        TableDetail
    },

    props: {
        show: Boolean,
        item: {
            type: Object,
            default: {}
        },
        columnsCollapsible:{
            type: Array
        }
    },

    data() {
        return {
            kitWasUsed: false,
            termsAndConditions: false,
            modalEndDate: false,
            createANewOrder: false,
            previousEndValue: null,
            orderStatuses: window.config.orderStatuses,
            stockStatuses: window.config.stockStatuses,
            modalOrder: this.show,
            form: {},
            mockPath: 'v1/order-detail',
            action: 0,
            stockAction: 0,
            mockData: null,
            genderOptions: [
                {value: 3, label: this.$T("gender male")},
                {value: 4, label: this.$T("gender female")}
            ],
            employeeOptions: [{value: "", label: "-"}],
            lendingKit: null,
            start_lending_at: '',
            end_lending_at: '',
            real_end_lending_at: '',
            showList: false,
            showIconDropdown: true,
            showOkImg: false,
            isCollapsibleOpen: true,
            reasonChoosed: null,
            scrollHeight: 200,
            dialog: false,
            lastDialog: false,
            isMobile: true,
            messageModal: '',
            noSoldReason: '',
            results: {
                data: [],
                excludeColumns: []
            },
            orderDetailColumns: [
                this.$T('kit code'),
                this.$T('model'),
                this.$T('color'),
                this.$T('lending point detail'),
                this.$T('final name'),
                this.$T('ending at')
            ],
        }
    },

    watch: {
        show(newVal) {
            this.modalOrder = newVal
        },

        item(newItem) {
            this.form = new Form(Object.assign(deepCopy(this.orderModel), newItem))
            this.form.birthdate = this.form.birthdate ? moment(this.form.birthdate).format('DD-MM-YYYY') : ''
            //this.lendingKit = `${this.form['lending_kit.product_model.description']} ${this.form['lending_kit_product_color.description']}`
            this.lendingKit = this.form['lending_kit.codentify']
            this.start_lending_at = this.startLendingAt
            this.end_lending_at = this.endLendingAt
            this.real_end_lending_at = this.realEndLendingAt
            this.getMockData()
        }
    },

    methods: {
        saveReason(reason){
            this.form.no_sold_reason_id = reason.value
            this.showOkImg = true
            this.showIconDropdown = false
            this.reasonChoosed = reason.value
            this.showList = !this.showList
        },
        openList(){
            this.showList = !this.showList
        },

        acceptTermsAndConditions() {
            this.termsAndConditions = false;
        },

        close() {
            this.action = 0
            this.stockAction = 0
            this.modalOrder = false
            this.modalEndDate = false
            this.$emit('close')
        },

        closeDialog(){
            this.dialog = false
            this.form.busy = false
        },

        closeLastDialog(){
            this.lastDialog = false
            this.dialog = false
        },

        onOk(){
            this.createANewOrder = true
            this.moveToNewOrder('completed', 'broken')
        },

        onLastOk(){
            if (this.$router.currentRoute.path === '/lending-point/orders/reservation') {
                this.$router.push({name: 'lending-point.orders'})
            }
            this.lastDialog = false
            this.dialog = false
        },

        onCancel(){
            this.createANewOrder = false
            this.form.busy = false
            //this.moveToNewOrder('completed', 'broken')
        },

        async getNotificationData() {
            const {data} = await axios.get(`${config.appUrl}/api/v1/notifications`)
            this.$store.commit('notifications/setToExpire', data.data.ordersToExpire)
            this.$store.commit('notifications/setExpiredNotClosed', data.data.ordersExpiredNotClosed)
            this.$store.commit('notifications/setKitsPendingReception', data.data.kitsPendingReception)
        },

        async getMockData() {
            this.mockData = null
            const {data} = await axios.get(`${config.appUrl}/api/${this.mockPath}/form-mock-data/${this.item.id || ''}`)
            this.mockData = data.data

            if (this.form['lending_kit.id']) {
                let lendingKit = await axios.get(`${config.appUrl}/api/lending-kit/${this.form['lending_kit.id']}`)
                if (lendingKit.data.kit_uses > 0) this.$set(this, 'kitWasUsed', true)
                lendingKit = lendingKit.data.model
                let product_color = await axios.get(`${config.appUrl}/api/product-color/${lendingKit.product_color_id}`)
                let product_model = await axios.get(`${config.appUrl}/api/product-model/${lendingKit.product_model_id}`)
                lendingKit.product_color = product_color.data.model
                lendingKit.product_model = product_model.data.model
                this.mockData.lendingKits = [lendingKit]
            }
        },

        makeActionDataAdjustments(action) {
            if ([1, 2, 3].includes(action)) {
                this.form.pickup_address = this.form.address
                this.form.pickup_address_2 = this.form.address_2
                this.form.pickup_zipcode = this.form.zipcode
                this.form.pickup_city = this.form.city
            }

            if ([1].includes(action)) {
                this.form.is_sold = 0
                this.stockAction = 0
            }

            if ([2].includes(action)) {
                this.form.is_sold = 1
                this.stockAction = 14
            }

            if ([3].includes(action)) {
                this.form.is_sold = 0
            }

            if ([4].includes(action)) {
                this.form.is_sold = 2
                this.stockAction = 0
            }
            if ([20].includes(action)) {
                this.form.is_sold = 0
                this.reasonChoosed = 5
                this.form.no_sold_reason_id = 5
            }
        },

        async save() {
            await this.form.patch(`${window.config.appUrl}/api/v1/order`)
                .then(({data}) => {
                    this.close()
                    this.$emit('updated')
                    this.messageModal = data.success.message
                    this.$q.dialog({
                        title: this.$T('success'),
                        message: data.success.message,
                        preventClose: true,
                        stackButtons: false,
                        ok: {
                            label: this.$T('close'),
                            outline: false,
                            rounded: true,
                            color: 'primary',
                            noCaps: true
                        },
                    })
                })
                .catch(response => console.log(response))
        },

        async moveTo(orderStatus, stockStatus = '') {
            //if the action is marked as "vendido" the alert should be appear
            /*if ([2, 6].includes(this.action) && this.kitWasUsed) {
                this.$q.dialog({
                    title: this.$T('warning'),
                    message: this.$T('this kit is used and not valid for sale'),
                    preventClose: true,
                    stackButtons: false,
                    ok: {
                        label: this.$T('close'),
                        outline: false,
                        rounded: true,
                        color: 'primary',
                        noCaps: true
                    },
                })
                return;
            }*/

            let greenGo = true

            //Set form to busy
            this.form.busy = true

            // Shorthand
            let role = this.user.role.name

            // Is Call Center closing order?
            let isCallCenterClosing = (orderStatus == 'pending-pick-up' &&
                role == 'Call Center')

            // Is Lending Point closing order?
            let isLendingPointClosing = (orderStatus == 'completed' &&
                (role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach'))

            // Is sold?
            let isSold = this.action != 1 && this.action != 3 && this.action != 20

            // PICA-12488 Customer Return Lost Kit and is Removed from Fraude
            if(this.action === 20) {
                let lendingKit = await axios.get(`${config.appUrl}/api/lending-kit/${this.form['lending_kit.id']}`)
                if(lendingKit.data.kit_uses >= 40) {
                    stockStatus = 'broken'
                } else {
                    stockStatus = 'clear'
                }
                orderStatus = 'completed'
            }

            //if the action is marked as "préstamo defactuoso" the stockStatus should be Roto
            if (this.action === 3) {
                stockStatus = 'broken'
                orderStatus = 'broked'
                if (this.user.lending_point && this.user.lending_point.enable_lending_creation) {
                    this.dialog = true
                    return
                    // await this.$q.dialog({
                    //     title: this.$T('warning'),
                    //     message: this.,
                    //     preventClose: true,
                    //     stackButtons: false,
                    //     ok: {
                    //         label: this.$T('yes'),
                    //         outline: false,
                    //         rounded: true,
                    //         color: 'highlight',
                    //         textColor: 'primary',
                    //         noCaps: true
                    //     },
                    //     cancel: {
                    //         color: 'primary',
                    //         label: this.$T('no'),
                    //         outlitne: true,
                    //         rounded: true,
                    //         noCaps: true
                    //     }
                    // }).then(() => createANewOrder = true)
                    //     .catch(() => createANewOrder = false)
                }
            }

            if (orderStatus === 'in-lending' && this.orderStatuses['PENDING'] === this.form['order_status.description']) {
                this.form.lending_kit_id = this.mockData.lendingKits[0].id
            }


            if (greenGo) {
                let limpiezaKitEnabled = false
                this.user.market.configurations.filter(config => {
                    if (config.description === 'enable_kit_clean') limpiezaKitEnabled = !!(parseInt(config.pivot.value))
                })
                if (limpiezaKitEnabled && stockStatus === 'available') stockStatus = 'clear'

                this.form.isSold = isSold
                this.form.create_new_order = this.createANewOrder
                await this.form.post(`${this.baseUrl}/order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
                    .then(({data}) => {
                        if (this.createANewOrder) {
                            this.form.start_lending_at = moment().format('YYYY-MM-DD')
                            this.form.end_lending_at = moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
                                .format('YYYY-MM-DD')
                            this.form.real_end_lending_at = null
                            this.form.original_order_id = this.form.id
                            this.$router.push({name: 'lending-point.order', params: {'formData': this.form}})
                        } else {
                            this.close()
                            this.$emit('updated')
                            //this.lastDialog = true
                            //this.messageModal = data.success.message
                            // this.$q.dialog({
                            //     title: this.$T('success'),
                            //     message: data.success.message,
                            //     preventClose: true,
                            //     stackButtons: false,
                            //     ok: {
                            //         label: this.$T('close'),
                            //         outline: false,
                            //         rounded: true,
                            //         color: 'primary',
                            //         noCaps: true
                            //     },
                            // }).then(() => {
                            //     if (this.$router.currentRoute.path === '/lending-point/orders/reservation') {
                            //         this.$router.push({name: 'lending-point.orders'})
                            //     }
                            // })
                            //console.log(data);
                            if(data.registroRedirect === true){
                                const baseUrl = window.config.registroWS+'/api/register-sale';
                                const params = new URLSearchParams({
                                    source: data.source,
                                    auth: data.auth,
                                    token: data.token,
                                    payload: data.payload,
                                    pos: data.pos
                                });

                                const url = `${baseUrl}?${params.toString()}`;
                                window.location.href = url;
                            }
                        }
                    })
                    .catch(response => console.log(response))
            }
            await this.getNotificationData()
        },

        async moveToNewOrder(orderStatus, stockStatus = '') {
            //if the action is marked as "vendido" the alert should be appear
            /*if ([2, 6].includes(this.action) && this.kitWasUsed) {
                this.$q.dialog({
                    title: this.$T('warning'),
                    message: this.$T('this kit is used and not valid for sale'),
                    preventClose: true,
                    stackButtons: false,
                    ok: {
                        label: this.$T('close'),
                        outline: false,
                        rounded: true,
                        color: 'primary',
                        noCaps: true
                    },
                })
                return;
            }*/

            let greenGo = true

            //Set form to busy
            this.form.busy = true

            // Shorthand
            let role = this.user.role.name

            // Is Call Center closing order?
            let isCallCenterClosing = (orderStatus == 'pending-pick-up' &&
                role == 'Call Center')

            // Is Lending Point closing order?
            let isLendingPointClosing = (orderStatus == 'completed' &&
                (role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach'))

            // Is sold?
            let isSold = this.action != 1 && this.action != 3

            //if the action is marked as "préstamo defactuoso" the stockStatus should be Roto
            if (this.action === 3) {
                stockStatus = 'broken'
                orderStatus = 'broked'
            }

            if (orderStatus === 'in-lending' && this.orderStatuses['PENDING'] === this.form['order_status.description']) {
                this.form.lending_kit_id = this.mockData.lendingKits[0].id
            }


            if (greenGo) {
                let limpiezaKitEnabled = false
                this.user.market.configurations.filter(config => {
                    if (config.description === 'enable_kit_clean') limpiezaKitEnabled = !!(parseInt(config.pivot.value))
                })
                if (limpiezaKitEnabled && stockStatus === 'available') stockStatus = 'clear'

                this.form.isSold = isSold
                this.form.create_new_order = this.createANewOrder
                await this.form.post(`${this.baseUrl}/order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
                    .then(({data}) => {
                        if (this.createANewOrder) {
                            this.form.start_lending_at = moment().format('YYYY-MM-DD')
                            this.form.end_lending_at = moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
                                .format('YYYY-MM-DD')
                            this.form.real_end_lending_at = null
                            this.form.original_order_id = this.form.id
                            this.form.guided_trial = !!this.form.guided_trial
                            this.form.follow_up = !!this.form.follow_up
                            this.form.terms_and_conditions = !!this.form.terms_and_conditions
                            this.form.fee_payment = !!this.form.fee_payment
                            this.$router.push({name: 'lending-point.order', params: {'formData': this.form}})
                        } else {
                            this.close()
                            this.$emit('updated')
                            this.lastDialog = true
                            this.messageModal = data.success.message
                            // this.$q.dialog({
                            //     title: this.$T('success'),
                            //     message: data.success.message,
                            //     preventClose: true,
                            //     stackButtons: false,
                            //     ok: {
                            //         label: this.$T('close'),
                            //         outline: false,
                            //         rounded: true,
                            //         color: 'primary',
                            //         noCaps: true
                            //     },
                            // }).then(() => {
                            //     if (this.$router.currentRoute.path === '/lending-point/orders/reservation') {
                            //         this.$router.push({name: 'lending-point.orders'})
                            //     }
                            // })
                        }
                    })
                    .catch(response => console.log(response))
            }
            await this.getNotificationData()
        }
    },

    updated(){
        if(this.mockData && this.dataDetailModal && this.isMobile){
            let lengthArray = this.dataDetailModal.length
            let lengthObj = Object.keys(this.dataDetailModal).length
            let indexLastElement = lengthObj - 1
            if(lengthArray === lengthObj){
                this.$refs[indexLastElement][0].classList.add('no-border')
            }
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),

        dataItem(){

            let lendingKitInformation = null
            if (this.mockData && this.mockData.hasOwnProperty('lendingKits')) {
                lendingKitInformation = this.mockData.lendingKits.find( lendingKit => {
                    return lendingKit.codentify === this.item['lending_kit.codentify']
                })
            }

            return [
                this.item['lending_kit.codentify'],
                lendingKitInformation && lendingKitInformation.hasOwnProperty('product_model') ? lendingKitInformation.product_model.description : '',
                lendingKitInformation && lendingKitInformation.hasOwnProperty('product_color') ? lendingKitInformation.product_color.description : '',
                this.item['lending_point.description'],
                this.item['firstname'] + ' ' + this.item['lastname'],
                moment(this.item['end_lending_at']).format('DD-MM-YYYY')
            ]
        },

        dataDetailModal(){

            let lendingKitInformation = null
            if (this.mockData && this.mockData.hasOwnProperty('lendingKits')) {
                lendingKitInformation = this.mockData.lendingKits.find( lendingKit => {
                    return lendingKit.codentify === this.item['lending_kit.codentify']
                })
            }

            return [
                {
                    column: this.$T('kit code'),
                    data: this.item['lending_kit.codentify']
                },
                {
                    column: this.$T('model'),
                    data: lendingKitInformation && lendingKitInformation.hasOwnProperty('product_model') ? lendingKitInformation.product_model.description : ''
                },
                {
                    column: this.$T('color'),
                    data: lendingKitInformation && lendingKitInformation.hasOwnProperty('product_color') ? lendingKitInformation.product_color.description : ''
                },
                {
                    column: this.$T('lending point detail'),
                    data: this.item['lending_point.description']
                },
                {
                    column: this.$T('final name'),
                    data: this.item['firstname'] + ' ' + this.item['lastname']
                },
                {
                    column: this.$T('ending at'),
                    data: moment(this.item['end_lending_at']).format('DD-MM-YYYY')
                }
            ]
        },

        baseUrl() {
            return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
        },

        startLendingAt() {
            if (!this.form.start_lending_at)
                return this.$T('not started yet')
            return moment(this.form.start_lending_at).format('DD-MM-YYYY')
        },

        endLendingAt() {
            if (!this.form.end_lending_at && !this.form.start_lending_at)
                return this.$_T(':days days after start', {days: this.mockData.lendingDays})
            else if (this.form.start_lending_at && !this.form.end_lending_at)
                return moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
                    .format('DD-MM-YYYY') + ' - ' + this.$T('planned')
            return moment(this.form.end_lending_at).format('DD-MM-YYYY')
        },

        realEndLendingAt() {
            if (!this.form.real_end_lending_at)
                return 'N.A.'
            return moment(this.form.real_end_lending_at).format('DD-MM-YYYY')
        },

        prefixedPhone() {
            let prefix = this.form.phone_prefix === '00' || !this.form.phone_prefix ? this.form.phone_prefix : this.form.phone_prefix.replace('00', '+')
            return this.form.phone ? `${prefix} ${this.form.phone}` : ''
        },

        formatedAddress() {
            if (this.form.address)
                return this.form.address + ', ' +
                    (this.form.address_2 ? this.form.address_2 + ', ' : '') +
                    this.form.city + '. ' +
                    this.$T('zip code') + ': ' + this.form.zipcode
            return ''
        },

        formatedPickupAddress() {
            if (this.form.pickup_address)
                return this.form.pickup_address + ', ' +
                    (this.form.pickup_address_2 ? this.form.pickup_address_2 + ', ' : '') +
                    this.form.pickup_city + '. ' +
                    this.$T('zip code') + ': ' + this.form.pickup_zipcode
            return ''
        },

        actions() {
            let order = this.item
            let role = this.user.role.name
            let orderStatus = this.form['order_status.description']
            let orderStatuses = this.orderStatuses

            let actions = []

            // Call Center
            if (order.delivery == this.$T('yes') && role == 'Call Center' && orderStatus == orderStatuses['IN_LENDING'])
                actions = actions.concat([
                    {value: 5, label: `${this.$T('pick up')} <strong>&gt; ${this.$T('no sold')}</strong>`},
                    {value: 6, label: `${this.$T('pick up')} <strong>&gt; ${this.$T('sold')}</strong>`}
                ])

            // Lending Point
            if ((role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || 'Remote Coach' === role || role == 'Call Center') && (orderStatus == orderStatuses['IN_LENDING'] || orderStatus == orderStatuses['IN_LENDING_DELAYED'])) {
                actions = actions.concat([
                    {value: 1, label: `${this.$T('no sold')}`},
                ])

                if ((role === 'Lending Point' || role === 'Sales Expert' || role == 'MUPI' || role === 'Remote Coach') && this.mockData.optionSoldDifferentKit === "1") {
                    actions = actions.concat([
                        {
                            value: 4,
                            label: `${this.$T('sold different kit')}`
                        },
                    ])
                }

                if (role != 'Call Center') {
                    let mktConfig = false
                    // Get the configuration market
                    this.user.market.configurations.filter(config => {
                        if (config.description === 'enable_completed_sold') {
                            mktConfig = !!(parseInt(config.pivot.value))
                        }
                    })
                    // If the configuration for market is 'ON'
                    if (mktConfig) {
                        // And on lending point the configuration is 'ON'
                        if (this.mockData.enable_completed_sold && this.mockData.enable_completed_sold === 1) {
                            actions = actions.concat([
                                {value: 2, label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold')}</strong>`}
                            ])
                        }
                    } else {
                        // If the configuration for market is 'OFF', always show the button
                        actions = actions.concat([
                            {value: 2, label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold')}</strong>`}
                        ])
                    }
                    actions = actions.concat([
                        {value: 3, label: `${this.$T('defective')} `},
                    ])
                }
            }

            // PICA-12488 Sale Expert Remove from Fraude
            if ((role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || 'Remote Coach' === role || role == 'Call Center') && orderStatus == orderStatuses['NOT_RETURNED']) {
                actions = actions.concat([
                    {value: 20, label: `Kit Devuelto`}
                ])
            }

            return actions
        },

        stockActions() {
            let role = this.user.role.name
            let orderStatus = this.form['order_status.description']
            let orderStatuses = this.orderStatuses

            let actions = [{value: 0, label: this.$T('no action')}]

            if ((orderStatus == orderStatuses['PENDING_PICKUP'] && role == 'Courier') ||
                ((orderStatus == orderStatuses['IN_LENDING'] || orderStatus == orderStatuses['IN_LENDING_DELAYED']) && (role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' ||
                    role == 'Call Center' || 'Remote Coach' === role)))
                actions = [
                    {
                        value: 0,
                        stockStatus: 'available',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('to available')}</strong>`
                    },
                    {
                        value: 11,
                        stockStatus: 'broken',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('broken')}</strong>`
                    },
                    {
                        value: 13,
                        stockStatus: 'not-returned',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('not returned')}</strong>`
                    },
                    {
                        value: 14,
                        stockStatus: 'sold',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('sold')}</strong>`
                    }
                ]

            return actions
        },

        canRegisterConsumer() {
            return this.action == 2 && ['Call Center', 'Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach'].includes(this.user.role.name)
        },

        maxBirthDate() {
            return moment().subtract(18, 'years').format('YYYY-MM-DD\THH:mm:ss.SSSZ')
        }
    },

    created() {
        if (!this.mockData) {
            this.getMockData()
        }
    },

    mounted(){
        this.isMobile = this.$q.platform.is.mobile
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/_orderDetail.vue